import React, { useEffect, useState } from "react";
import banner1 from "../../assets/images/Home/b1.png"
import banner2 from "../../assets/images/Home/b2.png"
import banner3 from "../../assets/images/Home/b3.png"
import person1 from "../../assets/images/Home/Pic1.jpeg";
import person2 from "../../assets/images/Home/Pic2.webp";
import person3 from "../../assets/images/Home/Pic3.webp";
import person4 from "../../assets/images/Home/Pic4.jpg";
import person5 from "../../assets/images/Home/Pic5.webp";
import person6 from "../../assets/images/Home/Pic6.jpeg";
import person8 from "../../assets/images/Home/Pic8.webp";
import Homesec from "./homesec2";
import Homesec3 from "./homesec3";
import Homesec4 from "./homesec4";
import { useSelector } from "react-redux";
import MembersSection from "./MembersSection";
import OurAttraction from "./OurAttraction";
import HomePopup from "./Popup";


const Home = () => {
    const content = {
        English: {
            slides: [
                { image: banner1, text: "Museums" },
                { image: banner2, text: "Monuments" },
                { image: banner3, text: "Excavations & Explorations" },
            ],
            heading: "Museums",
            members: [
                { img: person1, name: "Shri. Jishnu Dev Varma ", role: "Hon'ble Governor, Government of Maharashtra" },
                { img: person2, name: "Shri. Devendra Fadnavis", role: "Hon'ble Chief Minister, Government of Maharashtra" },
                { img: person3, name: "Shri. Eknath Shinde", role: "Hon'ble Deputy Chief Minister, Government of Maharashtra" },
                { img: person4, name: "Shrim. Sunetra Ajit Pawar", role: "Hon'ble Deputy Chief Minister, Government of Maharashtra" },
                { img: person5, name: "Adv.Shri. Ashish Shelar", role: "Hon'ble Minister, Department of Cultural Affairs, Government of Maharashtra" },
                { img: person6, name: "Dr. Kiran Kulkarni", role: "Hon’ble Secretary, Department of Cultural Affairs, Government of Maharashtra" },
                { img: person8, name: "Dr. Tejas Garge", role: "Director, Directorate of Archaeology and Museums, Government of Maharashtra" }
            ]
        },
        मराठी: {
            slides: [
                { image: banner1, text: "संग्रहालये" },
                { image: banner2, text: "स्मारके व पुरास्थळे" },
                { image: banner3, text: "उत्खनन आणि अन्वेषण" },
            ],
            heading: "संग्रहालये",
            members: [
                { img: person1, name: "श्री. जिष्णू देव वर्मा", role: "मा. राज्यपाल, महाराष्ट्र शासन" },
                { img: person2, name: "श्री. देवेंद्र फडणवीस", role: "माननीय मुख्यमंत्री, महाराष्ट्र शासन" },
                { img: person3, name: "श्री. एकनाथ शिंदे", role: "माननीय उपमुख्यमंत्री, महाराष्ट्र शासन" },
                { img: person4, name: "श्रीम. सुनेत्रा अजित पवार", role: "माननीय उपमुख्यमंत्री, महाराष्ट्र शासन" },
                { img: person5, name: "ॲड.श्री.आशिष शेलार", role: "माननीय मंत्री, सांस्कृतिक कार्य विभाग, महाराष्ट्र शासन" },
                { img: person6, name: "डॉ. किरण कुलकर्णी", role: "मा. सचिव, सांस्कृतिक कार्य विभाग ,महाराष्ट्र शासन" },
                { img: person8, name: "डॉ. तेजस गर्गे", role: "संचालक, पुरातत्त्व आणि संग्रहालय संचालनालय, महाराष्ट्र शासन" }
            ]
        },
    };

    const selectedLang = useSelector((state) => state.language.selectedLang);
    const t = content[selectedLang];
    const [currentIndex, setCurrentIndex] = useState(0);
    const bannerSlides = t.slides;

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % bannerSlides.length);
        }, 2000);

        return () => clearInterval(timer);
    }, [bannerSlides.length]);

    return (
        <>
        <HomePopup />
            <div className="w-full no-dark-bg">
                <div className="relative w-full h-60 md:h-[400px] lg:h-[550px] overflow-hidden">
                    {/* Background Image */}
                    {/* <div
                        className="absolute inset-0 bg-center bg-cover transition-all duration-1000"
                        style={{
                            backgroundImage: `url(${bannerSlides[currentIndex].image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    /> */}
                    <img
                        src={bannerSlides[currentIndex].image}
                        alt="Banner"
                        className="absolute inset-0 w-full h-full object-fill transition-all duration-1000 -top-2"
                    />
                    {/* Gradient Overlay */}
                    <div
                        className="absolute bottom-0 left-0 w-full h-[60%] pointer-events-none"
                    // style={{
                    //     background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 31.13%, #000000 87.67%)",
                    //     opacity: 1,
                    // }}
                    />
                    {/* Banner Text */}
                    {/* <div className="relative z-10 flex items-center justify-center h-full">
                        <h1 className="banner-heading text-white text-2xl sm:text-4xl md:text-5xl font-bold text-center px-4 transition-opacity duration-1000">
                            {bannerSlides[currentIndex].text}
                        </h1>
                    </div> */}
                    <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-10 px-4 text-center w-full">
                        <h1 className="banner-heading text-white text-2xl sm:text-4xl md:text-5xl font-bold transition-opacity duration-1000">
                            {bannerSlides[currentIndex].text}
                        </h1>
                    </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-6 px-4 sm:px-6 md:px-12 lg:px-16 mb-8 mt-8">
                    {/* Left Component */}
                    <div className="w-full lg:w-[64%]">
                        <MembersSection members={t.members} />
                    </div>

                    {/* Right Component */}
                    <div className="w-full lg:w-[36%] mt-4">
                        <Homesec />
                    </div>
                </div>
            </div>
            {/* <Homesec /> */}
            <OurAttraction />
            <Homesec3 />
            <Homesec4 />
        </>
    );
};

export default Home;
